import axios from 'axios'

export function counter_stats(num_days: number) {
  return axios.get('/vendor/dashboard/counter_stats', { params: { num_days } })
}

export function rfq_win_rate_by_company(num_days: number) {
  return axios.get('/vendor/dashboard/rfq_win_rate_by_company', { params: { num_days } })
}

export function order_response_time_by_company(num_days: number) {
  return axios.get('/vendor/dashboard/order_response_time_by_company', { params: { num_days } })
}

export function order_response_time_by_user(num_days: number) {
  return axios.get('/vendor/dashboard/order_response_time_by_user', { params: { num_days } })
}

export function quote_response_time_by_company(num_days: number) {
  return axios.get('/vendor/dashboard/quote_response_time_by_company', { params: { num_days } })
}

export function quote_response_time_by_user(num_days: number) {
  return axios.get('/vendor/dashboard/quote_response_time_by_user', { params: { num_days } })
}
